
import { Options, Vue } from "vue-class-component";
import { Watch } from "vue-property-decorator";
@Options({
  components: {},
})
export default class Header extends Vue {
  keyword = "";
  mounted() {
    this.keyword = (this.$route.params?.keyword || "") as string;
  }

  @Watch("$route")
  routeChange() {
    this.keyword = (this.$route.params?.keyword || "") as string;
  }
  handleChange() {
    if (this.keyword && this.keyword.trim()) {
      window.open(`/search/${this.keyword}`, "_blank");
      this.keyword = "";
    }
  }
}
